import { authHeaders, client } from '../../_shared/services/openapiClient';

type LegacyApiResult<T> = Promise<{ data?: T; error?: unknown }>;
const legacyClient = client as unknown as {
  GET: <T>(path: string, options?: unknown) => LegacyApiResult<T>;
  POST: <T>(path: string, options?: unknown) => LegacyApiResult<T>;
};

type ShortenLinkPayload = {
  artistName?: string | null;
  memberName?: string | null;
  userNickname?: string | null;
  photoCardImageUrls?: string[] | null;
};

type ShortenLink = {
  key?: string;
  payload?: ShortenLinkPayload | null;
};

export type CreateShortenLinkResponse = {
  key: string;
  shortenLink?: ShortenLink;
};

export type GetShortenLinkResponse = ShortenLink;

export async function createShortenLink(
  artistId: string,
  memberId: string
): Promise<CreateShortenLinkResponse> {
  const { data, error } = await legacyClient.POST<CreateShortenLinkResponse>(
    '/api/v1/shorten_links',
    {
      body: { shorten_link: { type: 'binder', artist_id: artistId, member_id: memberId } },
      headers: authHeaders()
    }
  );
  if (error) throw error;
  if (!data) throw new Error('Empty response from createShortenLink');
  return data;
}

export async function getShortenLink(key: string): Promise<GetShortenLinkResponse> {
  const { data, error } = await legacyClient.GET<{ shortenLink: GetShortenLinkResponse }>(
    '/api/v1/shorten_links/{key}',
    {
      params: { path: { key } }
    }
  );
  if (error) throw error;
  if (!data) throw new Error('Empty response from getShortenLink');
  return data.shortenLink;
}
